import { News } from "@/@types/index"
import { NewsResponse } from "../new/models/NewsResponse"

export function mapNews(news: NewsResponse): News {
  return {

    id: news.id,
    image: news.image,
    title: news.title,
    description: news.description,
    date: news.date,
    slug: news.slug,
    categorySlug: news.category_slug
  }
}